<template>
  <div>
    <!-- Show todays shift on Startscreen -->
    <v-parallax :src="infoscreen.today.img" height="180">
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12" v-if="infoscreen != undefined">
          <h1 class="display-1 font-weight-thin mb-4">Heute</h1>
          <h4 class="subheading">{{ infoscreen.today.label }}</h4>
          <small v-if="infoscreen.today.comment">{{ infoscreen.today.comment }}</small>
        </v-col>
      </v-row>
    </v-parallax>
    <v-divider></v-divider>
    <!-- Show shift of next two days on Startscreen -->
    <v-row no-gutters>
      <v-col cols="12" sm="6">
        <v-parallax :src="infoscreen.nextDays[0].img" height="150">
          <v-row align="center" justify="center" v-if="infoscreen != undefined">
            <v-col class="text-center" cols="12">
              <h1 class="display-1 font-weight-thin mb-4">Morgen</h1>
              <h4 class="subheading">{{ infoscreen.nextDays[0].label }}</h4>
              <small v-if="infoscreen.nextDays[0].comment">{{ infoscreen.nextDays[0].comment }}</small>
            </v-col>
          </v-row>
        </v-parallax>
      </v-col>
      <v-col cols="12" sm="6">
        <v-parallax :src="infoscreen.nextDays[1].img" height="150">
          <v-row align="center" justify="center" v-if="infoscreen != undefined">
            <v-col class="text-center" cols="12">
              <h1 class="display-1 font-weight-thin mb-4">Übermorgen</h1>
              <h4 class="subheading">{{ infoscreen.nextDays[1].label }}</h4>
              <small v-if="infoscreen.nextDays[1].comment">{{ infoscreen.nextDays[1].comment }}</small>
            </v-col>
          </v-row>
        </v-parallax>
      </v-col>
    </v-row>
    
    <v-divider></v-divider>

    <!-- Welcome text on Startscreen -->

    <v-card class="mx-auto">
      <v-card-text>
        <div>Ihr persönlicher Plan</div>
        <p class="display-1 text--primary">
          Lernen Sie die Funktionen dieser App kennen
        </p>
      </v-card-text>
    </v-card>

    <!-- Shift plan options / explanation on Startscreen -->
    <v-card
      color="#005ABB"
      raised
      elevation="5"
      @click="$emit('viewevent', 'me')"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title class="headline">Ihr Plan</v-card-title>
          <v-card-subtitle>
            Die Einsatzzeiten Ihrer Schicht und persönliche Einträge. Dies
            können zum Beispiel abweichende Schichten oder Abwesenheiten sein.
          </v-card-subtitle>
        </div>
        <v-avatar class="ma-3" color="white">
          <v-icon large color="#005ABB">mdi-account</v-icon>
        </v-avatar>
      </div>
    </v-card>
    <v-card
      color="#6FA0C2"
      raised
      elevation="5"
      @click="$emit('viewevent', 'cal')"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title class="headline">Kalender</v-card-title>
          <v-card-subtitle
            >Hier finden Sie die Einsatzzeiten der unterschiedlichen
            Schichten.</v-card-subtitle
          >
        </div>
        <v-avatar class="ma-3" color="white">
          <v-icon large color="#6FA0C2">mdi-calendar</v-icon>
        </v-avatar>
      </div>
    </v-card>
    <v-card
      color="#9FC9E6"
      raised
      elevation="5"
      @click="$emit('viewevent', 'team')"
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title class="headline">Team</v-card-title>
          <v-card-subtitle>
            Hier sind die persönlichen Eintäge von Ihren Kollegen zu finden.
          </v-card-subtitle>
        </div>
        <v-avatar class="ma-3" color="white">
          <v-icon large color="#9FC9E6">mdi-account-group</v-icon>
        </v-avatar>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["infoscreen"],
};
</script>
